import { render, staticRenderFns } from "./Frequencies.vue?vue&type=template&id=5e2ff7f9"
import script from "./Frequencies.vue?vue&type=script&lang=js"
export * from "./Frequencies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports